import { Controller } from "stimulus"
import IMask from 'imask'

export default class extends Controller {
  static targets = ["manual_checkbox", "amounts_currency_radio", "amounts_currency_radio_group", "rate_input", "manual_rates"]

  connect() {
    this.initializeRateInputMasks()
  }

  onManualChange(event) {
    this.updateRateInputsState()
  }

  initializeRateInputMasks() {
    this.rate_inputTargets.forEach(input => {
      IMask(input, {
        mask: Number,
        scale: 2,
        signed: false,
        thousandsSeparator: ' ',
        padFractionalZeros: false,
        normalizeZeros: true,
        radix: '.',
        mapToRadix: [','],
        min: 0
      })
    })
  }

  updateRateInputsState() {
    const isManual = this.manual_checkboxTarget.checked
    this.rate_inputTargets.forEach(input => {
      input.disabled = !isManual
      if (isManual) {
        input.required = true
      } else {
        input.required = false
      }
    })
  }

  disableAllRateInputs() {
    this.rate_inputTargets.forEach(input => {
      input.disabled = true
      input.required = false
    })
  }
}